import Config from '../../Config'
import store from '../../store'


const qs = require('query-string')

export const sharedService = {
  create,
  createRecuperar,
  update,
  _delete,
  read,
  _execute,
  sendFiles,
  encaminharVaga,
  getEmpresa
}


function create(model, obj, chave) {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': Config.authHeader()
    },
    body: JSON.stringify(obj)
  };

  return fetch(`${Config.baseUrl}/${model}/${chave}`, requestOptions)
    .then(response => {
      return response;
    })
    .catch(
      error => {
        return { 'error': error }
      }
    );
}

function createRecuperar(model, obj, chave) {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': Config.authHeader()
    },
    body: JSON.stringify(obj)
  };

  return fetch(`${Config.baseUrl}/${model}/${chave}/${obj.cpf}`, requestOptions)
    .then(response => {
      return response;
    })
    .catch(
      error => {
        return { 'error': error }
      }
    );
}




function encaminharVaga(model, obj, chave) {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': Config.authHeader()
    }
  };

  return fetch(`${Config.baseUrl}/${model}/${chave}/${obj.idVaga}`, requestOptions)
    .then(response => {
      return response;
    })
    .catch(
      error => {
        return { 'error': error }
      }
    );
}

function sendFiles(model, obj) {
  const formData = new FormData();
  formData.append('fileName', obj);
  const requestOptions = {
    method: 'POST',
    headers: {
      'Authorization': Config.authHeader()
    },
    body: formData
  };

  return fetch(`${Config.baseUrl}/${model}/${store.getters.getApiKey}`, requestOptions)
    .then(response => {
      return response;
    })
    .catch(
      error => {
        return { 'error': error }
      }
    );
}

async function update(model, obj, id) {
  const requestOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(obj)
  };

  return fetch(`${Config.baseUrl}/${model}/${id}`, requestOptions)
    .then(response => {
      return response;
    })
    .catch(
      error => {
        return { 'error': error }
      }
    );
}

async function _delete(model, id) {
  const requestOptions = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json'
    }
  };

  try {
    const response = await fetch(`${Config.baseUrl}/${model}/${id}`, requestOptions);
    return response;
  }
  catch (error) {
    return { 'error': error };
  }
}

function read(model, p, id = null) {
  let url = '';

  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': Config.authHeader()
    }
  };

  let params = qs.stringify(p)

  if (id) {
    url = Config.baseUrl + '/' + model + '/' + id
  } else if (p) {
    url = Config.baseUrl + '/' + model + '?' + params
  } else {
    url = Config.baseUrl + '/' + model
  }

  return fetch(url, requestOptions)
    .then(response => {
      if (response.status === 200) {
        return response.json();
      } else {
        return response.text();
      }
    })
    .catch(
      error => {
        return { 'error': error }
      }
    );
}

function getEmpresa() {
  const requestOptions = {
    method: 'GET'
  };

  return fetch(`${Config.baseUrl}/mycompany/${store.getters.getApiKey}`, requestOptions)
    .then(response => {
      return response.json();
    })
    .catch(
      error => {
        return { 'error': error }
      }
    );
}

function _execute(obj, model) {
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(obj)
  };

  return fetch(`${Config.baseUrl}/do/${model}`, requestOptions)
    .then(response => {
      if (response.status === 200) {
        response.json().then(function (obj) {
          if (obj.token) {
            localStorage.setItem('user', JSON.stringify(obj));
          }
          return obj;
        });
      } else {
        const obj = {
          error: response.text()
        }
        return obj;
      }
    })
    .catch(
      error => {
        return { 'error': error }
      }
    );
}
